import { today } from './format.js';

function csvValue(value) {
  if (value === undefined || value === null) return '';
  const str = String(value);
  return /[",\n\r]/.test(str) ? `"${str.replaceAll('"', '""')}"` : str;
}

export function downloadCsv(filename, columns, rows) {
  const header = columns.map((column) => csvValue(column.label)).join(',');
  const body = rows.map((row) => columns.map((column) => csvValue(column.value(row))).join(','));
  const csv = `\uFEFF${[header, ...body].join('\n')}`;
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${filename}-${today()}.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
